import { cloneDeep, uniqueId } from 'lodash-es'
import { dfs } from '@/common/utils.ts'
import { caasLocalMenu } from '@/utils/localMenu.ts'

export const resolveCAASMenu = menuData => {
  const nextMenu = cloneDeep(menuData)

  dfs(nextMenu, d => {
    if (d.key === 'CAAS') {
      const caasMenu = d.children || []
      d.children = [...caasMenu, ...caasLocalMenu]

    }
    // 过滤掉系统配置菜单
    if (d.children?.find(d => d.nid === '10052')) {
      d.children = d.children.filter(d => d.nid !== '10052')
      return true
    }
  })
  return nextMenu
}

export const covertMenu = menuList => {
  const rootKeys: string[] = []

  const menus = menuList
    ?.filter?.(d => d.sysVisibleFlag !== false)
    .map(item => {
      return {
        ...item,
        // key: uniqueId(),
        id: item?.key,
      }
    })

  dfs(menus, (d, level) => {
    d.label = d.name
    d.level = level
    d.code = d.key
    // d.key = uniqueId()
    d.apppath = d.appPath || d.apppath
    delete d.sysVisibleFlag
    delete d.sortNumber
    delete d.appPath
    if (!d.children?.length) {
      delete d.children
    }
    // TODO: 临时处理
    d.icon = null
    // d.icon = convertIcon(d.icon)
    // d.label = convertLabel(d.label, level, d.children?.length)
  })
  menus.map(item => rootKeys.push(item.key))
  return [menus, rootKeys]
}
